interface Logger {
  log: (...args: unknown[]) => void;
  warn: (...args: unknown[]) => void;
  error: (...args: unknown[]) => void;
  info: (...args: unknown[]) => void;
  debug: (...args: unknown[]) => void;
}

const isDevelopment = import.meta.env.DEV;

const createLogger = (): Logger => {
  const noop = () => {};
  
  return {
    log: isDevelopment ? console.log.bind(console) : noop,
    warn: console.warn.bind(console),
    error: console.error.bind(console),
    info: isDevelopment ? console.info.bind(console) : noop,
    debug: isDevelopment ? console.debug.bind(console) : noop,
  };
};

export const logger = createLogger();
